<template>
  <div>
    <div class="page-header page-header-small">
      <parallax
        class="page-header-image"
        style="background-image: url('img/ea-05.jpg')" >
      </parallax>
      <div class="content-center">
        <div class="container">
          <img class="n-logo" src="img/stormhaven-logo.small.png" alt="" />
          <h1 class="title">Products</h1>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="content-center">
        <div class="container">
          <div class="row">
            <div class="col-md-8 ml-auto mr-auto text-center">
              <p>Stormhaven Studios, LLC is the developer of the <a href="https://www.embersadrift.com/" target="_blank">Embers Adrift MMORPG</a>.</p>
              <a href="https://www.embersadrift.com/" target="_blank"><img src="img/embers-adrift.png" alt="Embers Adrift" /></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'products',
  bodyClass: 'landing-page'
};
</script>
<style></style>
